import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn,FaWhatsapp } from 'react-icons/fa';
import logo from "../../Images/Logo.png";

const Footer = () => {
  return (
    <footer className="bg-yellow-100 text-gray-700 pt-10 pb-6 px-6 md:px-20">
      {/* Centered Logo and Title */}
      <div className="flex md:flex-row flex-col justify-center items-center mb-6">
        <a href="/" className="flex items-center space-x-4 h-[64px]">
          <img
            src={logo}
            alt="VamikaTours Logo"
            className=" md:top-[-17px] h-[132px] w-[132px]"
          />
        </a>
        <span className="text-xl md:mt-[-25px] font-bold md:ml-[-23px]">
          VamikaTours
        </span>
      </div>


      {/* Footer Main Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 text-center md:text-left">
        {/* Company Info & Social */}
        <div className="md:col-span-1 flex flex-col items-center md:items-start">
          <h4 className="font-semibold mb-3">Company</h4>
          <ul className="space-y-1">
            <li><a href="/about-us">About us</a></li>
            <li><a href="/contact">Contact us</a></li>
          </ul>

          <div className="mt-8">
            <h3 className="text-lg font-semibold text-gray-700 mb-3">Follow us</h3>
            <div className="flex space-x-4 justify-center">
              {/* <a href="#" className="text-blue-600 hover:text-blue-800 transition">
                <FaFacebookF size={20} />
              </a> */}
              <a href="https://chat.whatsapp.com/HLY4HbwuVJTDJ0Q7cfuYW" className="text-blue-600 hover:text-blue-800 transition">
                <FaWhatsapp size={20} />
              </a>
              {/* <a href="#" className="text-sky-500 hover:text-sky-700 transition">
                <FaTwitter size={20} />
              </a> */}
              <a href="https://www.instagram.com/vamikatours?igsh=ano0cHR0d2h0czRi&utm_source=qr" className="text-pink-500 hover:text-pink-700 transition">
                <FaInstagram size={20} />
              </a>
              {/* <a href="#" className="text-blue-700 hover:text-blue-900 transition">
                <FaLinkedinIn size={20} />
              </a> */}
            </div>
          </div>
        </div>

        {/* Domestic Tour Packages */}
        <div>
          <h4 className="font-semibold mb-3">DOMESTIC TOUR PACKAGES</h4>
          <ul className="space-y-1">
            <li>Best of Rajasthan</li>
            <li>Best of Wild Life</li>
            <li>Golden Triangle</li>
            <li>Majestic Rajasthan</li>
            <li>Rajasthan all the Way</li>
            <li>Romantic Rajasthan</li>
            <li>Royal Rajasthan</li>
            <li>Temple & Heritage</li>
            <li>Kashmir Package</li>
            <li>Kashmir Summer Package</li>
            <li>Andaman Nicobar</li>
            <li>Kerala Tour Packages</li>
            <li>Goa Tour Packages</li>
            <li>Leh Ladakh Tour Packages</li>
            <li>Sikkim Tour Packages</li>
          </ul>
        </div>

        {/* Honeymoon Packages */}
        <div>
          <h4 className="font-semibold mb-3">HONEYMOON TOUR PACKAGES</h4>
          <ul className="space-y-1">
            <li>Delhi Agra Jaipur Delhi</li>
            <li>Goa</li>
            <li>Jaipur Jodhpur Jaisalmer Bikaner Jaipur</li>
            <li>Jaipur Ajmer Pushkar Jodhpur Udaipur</li>
            <li>Kerala</li>
            <li>Leh ladakh</li>
            <li>Love in Kashmir</li>
            <li>Nainital</li>
            <li>Romantic Udaipur</li>
            <li>Shimla Manali</li>
            <li>Andman-Nicobar</li>
            <li>Bali</li>
            <li>Darjeeling Gangtok</li>
          </ul>
        </div>

        {/* Outbound Tour Packages */}
        <div>
          <h4 className="font-semibold mb-3">OUTBOUND TOUR PACKAGES</h4>
          <ul className="space-y-1">
            <li>Dubai Tour Packages</li>
            <li>Japan Tour Packages</li>
            <li>Mauritius Tour Packages</li>
            <li>Cambodia Tour Packages</li>
            <li>Indonesia Tour Packages</li>
            <li>Laos Tour Packages</li>
            <li>Vietnam Tour Packages</li>
            <li>Sri lanka Tour Packages</li>
            <li>Thailand Tour Packages</li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="max-w-7xl mx-auto mt-10 border-t pt-6">
        {/* <div className="flex flex-col items-center justify-center md:flex-row  md:items-center gap-4 mb-4">

          Quick Links aligned right
          <div className="flex flex-wrap gap-4 text-sm text-gray-500 md:ml-auto">
            <a href="#" className="hover:underline">Privacy</a>
            <a href="#" className="hover:underline">Sitemap</a>
            <a href="#" className="hover:underline">Company details</a>
          </div>
        </div> */}

        {/* Copyright */}
        <div className="text-sm text-gray-500 text-center ">
          © 2024 VamikaTours, Inc. All rights reserved.
        </div>
      </div>

    </footer>
  );
};

export default Footer;
